import { render, staticRenderFns } from "./BacktestMACDView.vue?vue&type=template&id=054ede94&scoped=true"
import script from "./BacktestMACDView.vue?vue&type=script&lang=js"
export * from "./BacktestMACDView.vue?vue&type=script&lang=js"
import style0 from "./BacktestMACDView.vue?vue&type=style&index=0&id=054ede94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ede94",
  null
  
)

export default component.exports